import { plaintextValidator } from '../fields';

const config = { mandatory: true };

export default {
  host: plaintextValidator(config),
  port: plaintextValidator(config),
  userName: plaintextValidator(config),
  password: plaintextValidator(config)
};
